import React from "react";

// This component is used to format text output from the database. It will convert markdown links to html links.
// It will also convert new lines to <br> tags to be seen in the UI.
export const FormatTextOutput = ({ text }) => {

    if (!text) {
        return null;
    }

    const lines = text.split('\n');
    return lines.map((line, index) => {
        const parts = line.split(/(\[.*?\]\(.*?\))/g);
        return (
            <React.Fragment key={index}>
                {parts.map((part, i) => {
                    const match = part.match(/\[(.*?)\]\((.*?)\)/);
                    if (match) {
                        return <a key={i} href={match[2]}>{match[1]}</a>;
                    }
                    return part;
                })}
                <br />
            </React.Fragment>
        );
    });
};